// extracted by mini-css-extract-plugin
export var formContainer = "_mf-0";
export var message = "_mf-1";